import { motion } from "framer-motion";
import styles from "../../styles/about/about.module.css";
import dayjs from "dayjs";

const transitionConfig = {
  duration: 0.65,
};

const viewportConfig = {
  once: true,
  margin: "0px 0px -100px 0px",
};

const Personal = () => {
  const birthday = "2000-12-24";

  return (
    <motion.div
      className={styles.personalContainer}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={transitionConfig}
      viewport={viewportConfig}
    >
      <div className={styles.personal}>
        <div>
          <motion.h3
            className={styles.title}
            initial={{ opacity: 0, y: -50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={transitionConfig}
            viewport={viewportConfig}
          >
            Name:
          </motion.h3>

          <motion.p
            className={styles.subtitle}
            initial={{ opacity: 0, y: -50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={transitionConfig}
            viewport={viewportConfig}
          >
            Joaquín Vega
          </motion.p>
        </div>

        <div>
          <motion.h3
            className={styles.title}
            initial={{ opacity: 0, y: -50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={transitionConfig}
            viewport={viewportConfig}
          >
            Current Age:
          </motion.h3>

          <motion.p
            className={styles.subtitle}
            initial={{ opacity: 0, y: -50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={transitionConfig}
            viewport={viewportConfig}
          >
            {dayjs().diff(birthday, "years")}
          </motion.p>
        </div>

        <div>
          <motion.h3
            className={styles.title}
            initial={{ opacity: 0, y: -50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={transitionConfig}
            viewport={viewportConfig}
          >
            Country:
          </motion.h3>

          <motion.p
            className={styles.subtitle}
            initial={{ opacity: 0, y: -50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={transitionConfig}
            viewport={viewportConfig}
          >
            Uruguay
          </motion.p>
        </div>
      </div>

      <div>
        <motion.h3
          className={styles.title}
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={transitionConfig}
          viewport={viewportConfig}
        >
          Technologies I want to learn next:
        </motion.h3>

        <motion.p
          className={styles.subtitle}
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={transitionConfig}
          viewport={viewportConfig}
        >
          Angular, Node JS, Express, Mongo DB
        </motion.p>
      </div>
    </motion.div>
  );
};

export default Personal;
